export default __webpack_public_path__ + "static/media/whiteGlobe.fcae2222.png";